import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/images/code-clan-logo.png'


const _hoisted_1 = { ref: "pdfZone" }
const _hoisted_2 = {
  class: "tbl",
  cellspacing: "1",
  cellpadding: "5"
}
const _hoisted_3 = {
  class: "tbl",
  cellspacing: "1",
  cellpadding: "5"
}
const _hoisted_4 = { class: "card pl-0 pr-0" }
const _hoisted_5 = { class: "card pl-0 pr-0" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "card blue text_white" }
const _hoisted_12 = { class: "card blue text_white" }
const _hoisted_13 = { class: "d-flex flex-wrap flex-column flex-md-row-reverse ml-auto mr-auto mr-md-1 gap-10px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_ctx.payRun)
    ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        loading: _ctx.loading || _ctx.pdfDownloadLoading,
        disabled: _ctx.loading || _ctx.pdfDownloadLoading
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _cache[2] || (_cache[2] = _createElementVNode("span", null, " PayRun Detail", -1)),
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      icon: "",
                      dark: "",
                      onClick: _ctx.close,
                      fab: "",
                      class: "error",
                      "x-small": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[1] || (_cache[1] = [
                            _createTextVNode("mdi-close")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "page-content" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      md: "9",
                      style: {"font-size":"20px"},
                      class: "pt-12"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("strong", {
                          class: _normalizeClass({ 'blue--text': !_ctx.isDarkTheme, text_white: _ctx.isDarkTheme })
                        }, _toDisplayString(_ctx.payRun.TeamMember?.Name), 3)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      class: "text-right pdf-ignore",
                      md: "3"
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createElementVNode("img", {
                          src: _imports_0,
                          style: {"width":"100%"}
                        }, null, -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      md: "12",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _cache[4] || (_cache[4] = _createElementVNode("b", null, "Duration:", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.payRun.FromDate)) + " ~ " + _toDisplayString(_ctx.formatDate(_ctx.payRun.ToDate)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      md: "12",
                      cols: "12",
                      class: "payrun-table"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("table", _hoisted_2, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _cache[5] || (_cache[5] = _createElementVNode("th", null, "Date / Commitment", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.splitWeeks, (w, index) => {
                                return (_openBlock(), _createElementBlock("th", { key: index }, "Week" + _toDisplayString(index + 1), 1))
                              }), 128)),
                              _cache[6] || (_cache[6] = _createElementVNode("th", null, "Total Hours", -1)),
                              _cache[7] || (_cache[7] = _createElementVNode("th", null, "Adjustment (hours)", -1)),
                              _cache[8] || (_cache[8] = _createElementVNode("th", null, "Performance coefficient", -1)),
                              _cache[9] || (_cache[9] = _createElementVNode("th", { style: {"width":"100px"} }, "Total Pay", -1))
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tmPayRunItems, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: `${index}-commitments-${item.Commitment && item.Commitment.id}`
                              }, [
                                _createElementVNode("td", null, _toDisplayString(item.Commitment && item.Commitment?.Name), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Weeks, (w, index) => {
                                  return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(w.Hours), 1))
                                }), 128)),
                                _createElementVNode("td", null, _toDisplayString(item.TotalHours), 1),
                                _createElementVNode("td", null, _toDisplayString(item.AdjustmentHours), 1),
                                _createElementVNode("td", null, _toDisplayString(item.SeniorityLevel), 1),
                                _createElementVNode("td", null, _toDisplayString(item.TotalPay) + " AUD", 1)
                              ]))
                            }), 128)),
                            _createElementVNode("tr", null, [
                              _cache[10] || (_cache[10] = _createElementVNode("td", null, "SUM", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.splitWeeks, (w, index) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: w.from
                                }, _toDisplayString(_ctx.getSumTimesheetOfWeek(index)), 1))
                              }), 128)),
                              _createElementVNode("td", null, _toDisplayString(_ctx.sumTotalHours), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.sumAdjustments), 1),
                              _cache[11] || (_cache[11] = _createElementVNode("td", null, "-", -1)),
                              _createElementVNode("td", null, _toDisplayString(_ctx.sumTotalPay) + " AUD", 1)
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.lmPayRunItems && _ctx.lmPayRunItems.length > 0)
              ? (_openBlock(), _createBlock(_component_v_card_text, {
                  key: 0,
                  class: "page-content"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          md: "12",
                          cols: "12"
                        }, {
                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                            _createElementVNode("b", null, "Line Manager Payments: ", -1)
                          ])),
                          _: 1
                        }),
                        _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                        _createVNode(_component_v_col, {
                          md: "12",
                          cols: "12",
                          class: "payrun-table"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("table", _hoisted_3, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _cache[13] || (_cache[13] = _createElementVNode("th", null, "Date / Commitment", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.splitWeeks, (w, index) => {
                                    return (_openBlock(), _createElementBlock("th", { key: index }, "Week" + _toDisplayString(index + 1), 1))
                                  }), 128)),
                                  _cache[14] || (_cache[14] = _createElementVNode("th", null, "Total Hours", -1)),
                                  _cache[15] || (_cache[15] = _createElementVNode("th", null, "Adjustment (hours)", -1)),
                                  _cache[16] || (_cache[16] = _createElementVNode("th", null, "Performance coefficient", -1)),
                                  _cache[17] || (_cache[17] = _createElementVNode("th", { style: {"width":"100px"} }, "Total Pay", -1))
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lmPayRunItems, (item, index) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: `${index}-lm-commitments-${item.Commitment && item.Commitment.id}`
                                  }, [
                                    _createElementVNode("td", null, _toDisplayString(item.Commitment && item.Commitment?.Name), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Weeks, (w, index) => {
                                      return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(w.Hours), 1))
                                    }), 128)),
                                    _createElementVNode("td", null, _toDisplayString(item.TotalHours), 1),
                                    _createElementVNode("td", null, _toDisplayString(item.AdjustmentHours), 1),
                                    _createElementVNode("td", null, _toDisplayString(item.SeniorityLevel), 1),
                                    _createElementVNode("td", null, _toDisplayString(item.TotalPay) + " AUD", 1)
                                  ]))
                                }), 128)),
                                _createElementVNode("tr", null, [
                                  _cache[18] || (_cache[18] = _createElementVNode("td", null, "SUM", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.splitWeeks, (w, index) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                      key: w.from
                                    }, _toDisplayString(_ctx.lmGetSumTimesheetOfWeek(index)), 1))
                                  }), 128)),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.lmSumTotalHours), 1),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.lmSumAdjustments), 1),
                                  _cache[19] || (_cache[19] = _createElementVNode("td", null, "-", -1)),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.lmSumTotalPay) + " AUD", 1)
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_card_text, { class: "page-content" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      md: "6",
                      sm: "6",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              md: "8",
                              sm: "8",
                              cols: "8"
                            }, {
                              default: _withCtx(() => _cache[21] || (_cache[21] = [
                                _createTextVNode("Admin Approved Payrun:")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              md: "4",
                              sm: "4",
                              cols: "4",
                              class: "text-right"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.payrunAuditTrailDetail && _ctx.payrunAuditTrailDetail[0] && _ctx.payrunAuditTrailDetail[0].AdminApprovedDate
                      ? _ctx.payrunAuditTrailDetail[0].AdminApprovedDate
                      : "Not approved"), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              md: "12",
                              sm: "12",
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_divider)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              md: "8",
                              sm: "12",
                              cols: "8"
                            }, {
                              default: _withCtx(() => _cache[22] || (_cache[22] = [
                                _createTextVNode("Team Member Approved Payrun:")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              md: "4",
                              sm: "12",
                              cols: "4",
                              class: "text-right"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.payrunAuditTrailDetail && _ctx.payrunAuditTrailDetail[0] && _ctx.payrunAuditTrailDetail[0].TMApprovedDate
                      ? _ctx.payrunAuditTrailDetail[0].TMApprovedDate
                      : "Not approved"), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              md: "12",
                              sm: "12",
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_divider)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      md: "6",
                      sm: "6",
                      cols: "0"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AuAdjustments, (ad, idx) => {
                          return (_openBlock(), _createBlock(_component_v_row, {
                            key: 'aud_adj_' + idx
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                md: "6",
                                sm: "6",
                                cols: "7"
                              }, {
                                default: _withCtx(() => [
                                  _cache[23] || (_cache[23] = _createTextVNode(" Adjustments AUD ")),
                                  _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                                  _createElementVNode("small", null, _toDisplayString(ad.description), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, {
                                md: "6",
                                sm: "6",
                                cols: "5",
                                class: "text-right"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_6, _toDisplayString(ad.adjustment) + " AUD", 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, {
                                md: "12",
                                sm: "12",
                                cols: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_divider)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        (_ctx.AuLoanItems)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AuLoanItems.filter((c) => !c.IsDeleted), (ad, idx) => {
                                return (_openBlock(), _createBlock(_component_v_row, {
                                  key: 'aud_loan_' + idx
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      md: "6",
                                      sm: "6",
                                      cols: "7"
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[25] || (_cache[25] = _createTextVNode(" Loan Adjustment AUD ")),
                                        _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                                        _createElementVNode("small", null, _toDisplayString(ad.Description), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      md: "6",
                                      sm: "6",
                                      cols: "5",
                                      class: "text-right"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_8, _toDisplayString(ad.Amount) + " AUD", 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      md: "12",
                                      sm: "12",
                                      cols: "12"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_divider)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_row, { class: "pt-3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              md: "6",
                              sm: "6",
                              cols: "7"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Exchange rate " + _toDisplayString(_ctx.exchangeCurrencyId), 1),
                                _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              md: "6",
                              sm: "6",
                              cols: "5",
                              class: "text-right"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.payRun.ExchangeRate), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              md: "12",
                              sm: "12",
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_divider)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secondaryAdjustments, (ad, idx) => {
                          return (_openBlock(), _createBlock(_component_v_row, {
                            key: 'secondary_adj _' + idx
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                md: "6",
                                sm: "6",
                                cols: "7"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Adjustments " + _toDisplayString(_ctx.exchangeCurrencyId) + " ", 1),
                                  _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
                                  _createElementVNode("small", null, _toDisplayString(ad.description), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, {
                                md: "6",
                                sm: "6",
                                cols: "5",
                                class: "text-right"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_10, _toDisplayString(ad.adjustment) + " " + _toDisplayString(_ctx.exchangeCurrencyId), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, {
                                md: "12",
                                sm: "12",
                                cols: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_divider)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              md: "6",
                              sm: "6",
                              cols: "7"
                            }, {
                              default: _withCtx(() => _cache[29] || (_cache[29] = [
                                _createElementVNode("b", null, "Total pay AUD", -1)
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              md: "6",
                              sm: "6",
                              cols: "5",
                              class: "text-right"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatNumber(_ctx.payRun.AUDTotalPay)) + " AUD", 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              md: "12",
                              sm: "12",
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_divider)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              md: "6",
                              sm: "6",
                              cols: "7"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("b", null, "Total pay " + _toDisplayString(_ctx.exchangeCurrencyId), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              md: "6",
                              sm: "6",
                              cols: "5",
                              class: "text-right"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formatNumber(_ctx.payRun.LCTotalPay)) + " " + _toDisplayString(_ctx.exchangeCurrencyId), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.payRun.Payments && _ctx.payRun.Payments.length > 0)
                  ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          md: "12",
                          cols: "12"
                        }, {
                          default: _withCtx(() => _cache[30] || (_cache[30] = [
                            _createElementVNode("b", null, "Payment History", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_data_table, {
                              "hide-default-footer": true,
                              class: "pt-0 payRunActivityList",
                              items: _ctx.payRun.Payments,
                              headers: _ctx.headers
                            }, {
                              "item.LCTotalPay": _withCtx(({ item }) => [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.formatNumber(item.LCTotalPay)) + " " + _toDisplayString(_ctx.exchangeCurrencyId), 1)
                              ]),
                              "item.PaymentDate": _withCtx(({ item }) => [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.formatDate(item.PaymentDate)), 1)
                              ]),
                              "item.PaymentRefNo": _withCtx(({ item }) => [
                                _createElementVNode("strong", null, _toDisplayString(item.PaymentRefNo), 1)
                              ]),
                              _: 1
                            }, 8, ["items", "headers"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ], 512),
          _createVNode(_component_v_card_actions, { class: "action-bottons" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                (!_ctx.isForAdmin && _ctx.payRun.AdminApproved && !_ctx.payRun.TMApproved)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "primary_btn",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmedByTm()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[31] || (_cache[31] = [
                            _createTextVNode("mdi-check-all")
                          ])),
                          _: 1
                        }),
                        _cache[32] || (_cache[32] = _createTextVNode(" Approve"))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn, {
                  text: "",
                  onClick: _ctx.close
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => _cache[33] || (_cache[33] = [
                        _createTextVNode("mdi-close")
                      ])),
                      _: 1
                    }),
                    _cache[34] || (_cache[34] = _createTextVNode(" Close"))
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: _ctx.downloadPDF
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => _cache[35] || (_cache[35] = [
                        _createTextVNode("mdi-printer")
                      ])),
                      _: 1
                    }),
                    _cache[36] || (_cache[36] = _createTextVNode(" Download PDF"))
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading", "disabled"]))
    : _createCommentVNode("", true)
}